/**
@ngdoc directive
@name xmsTooltip

@description
Tooltip.

@param {string} xms-tooltip content of the tooltip
@param {string} tooltip-text content of the tooltip as separate component for Grails compatibility
@param {string} tooltip-id for accessibility and aria-describedby attribute
@param {boolean=} tooltip-icon either add or not the icon classes (true by default)
@param {url=} tooltip-ajax load the tooltip with ajax call
@param {boolean=} tooltip-append append element with tooltip (false by default) - this is done only for command links tooltip
@param {DOMelement} tooltip-append-tag tooltip html element (&lt;a&gt; by default)
@param {boolean} no-box-edge will position tooltip next to label or push it all the way to the right of the label
@param {string} tooltip-placement position of the toolitp (default is auto (based on window size the tooltip position will be determined), expected values: top|bottom|right|left)
@param {expression} always-show if the expression is truthy/falsy then tooltip is always visible below modals respectively (default false)
@param {expression} always-show-modal if the expression is truthy/falsy then tooltip is always visible above modals respectively (default false)

*/

(function() {

    'use strict';

    // 'boxEdge' / or other than 'boxEdge'; - it will either be at the box edge or just after label
    var globalTooltipPositionConfig = IS_HIGH_CONTRAST ? 'noBoxEdge' : 'boxEdge';

    var xmsTooltip = function($compile, $sanitize, ajaxCall) {
        return {
            restrict: 'A',
            scope: true,
            transclude: false,
            replace: false,
            link: {
                pre: function(scope, element, attrs){
                    var tooltipText;
                    if( angular.isDefined(attrs.ajaxTooltip) ) {
                        tooltipText = "{{tooltipText}}";
                        ajaxCall.getData(attrs.ajaxTooltip).then(function(response){
                            initTooltip(response.data);
                        }, function(){
                            console.warn("ajax-tooltip couldn't be loaded");
                        });
                    } else {
                        tooltipText = (angular.isDefined(attrs.tooltipText) && attrs.tooltipText!='') ? attrs.tooltipText : attrs.xmsTooltip;
                        initTooltip(tooltipText);
                    }


                    function initTooltip(tooltipText){
                        var tooltipClass = '';
                        var tooltipPlacement = 'auto';
                        if(tooltipText.length > 200) {
                            tooltipClass = 'tooltip-long';
                            if(tooltipText.length > 250) {
                                tooltipClass = 'tooltip-very-long';
                            }
                        }

                        tooltipText = $sanitize(tooltipText);
                        scope.tooltipText = tooltipText;

                        if(angular.isDefined(attrs.tooltipClass)){
                            tooltipClass += ' '+attrs.tooltipClass;
                        }

                        var alwaysShow = angular.isDefined(attrs.alwaysShow)
                        var alwaysShowModal = angular.isDefined(attrs.alwaysShowModal)

                        if(alwaysShow && !alwaysShowModal) {
                            tooltipClass += ' tooltip-always-show';
                        }

                        if(angular.isDefined(attrs.tooltipPlacement)){
                            tooltipPlacement = attrs.tooltipPlacement;
                        }

                        var elementTagName = element[0].tagName;
                        var elementType    = element[0].type;


                        if( (elementTagName=='INPUT' && elementType!='submit' && elementType!='button') || elementTagName=='SELECT' || elementTagName=='TEXTAREA'){
                            console.error([
                                'xms-tooltip will not work directly on form elements ie. <input> (apart from submit input) or <select> or <textarea>.',
                                ' Please place the tooltip on <label> element OR create <a> element OR use Angular UI uib-tooltip/uib-tooltip-html directive (which xms-tooltip is wrapper of)',
                                ' with the following attributes: tooltip-append-to-body="true" tooltip-trigger="\'focus mouseenter\'".'].join(''));
                        } else if(elementTagName == 'LABEL' || attrs.tooltipAppend=="true"){ // if append or LABEL element

                            var id='';
                            if(elementTagName == 'LABEL') {
                                var insideField = element.find("[name]");

                                if(insideField.length){
                                    // wrapping label (ie. for checkbox)
                                    var field = angular.element(insideField[0]);
                                    id = field.attr('name');
                                    field.attr('aria-describedby', id+'.tooltip');
                                } else {
                                    // regular label
                                    angular.element( document.getElementById( attrs['for'] ) ).attr('aria-describedby', attrs['for']+'.tooltip');
                                    id = attrs['for'];

                                    if(globalTooltipPositionConfig == 'boxEdge') {
                                        if( !angular.isDefined(attrs.noBoxEdge) || !attrs.noBoxEdge == 'true'){
                                            element.wrap('<span class="tooltip-label-wrap"></span>');
                                        }
                                    }
                                }
                                id=' id="'+id+'.tooltip"';
                            }

                            var tooltipTag = angular.isDefined(attrs.tooltipAppendTag) && attrs.tooltipAppendTag=='span' ? 'span' : 'a href="javascript:void(0);"'; // <a> by default
                            var attrClass  = angular.isDefined(attrs.ajaxTooltip) ? "ajax-tooltip " : "";
                            var tooltip = [
                                '<'+tooltipTag + id+' class="'+attrClass+'tooltip-icon glyphicon glyphicon-question-sign" tabindex="0" tooltip-placement="'+tooltipPlacement+'"',
                                    'uib-tooltip-html="tooltipText" tooltip-append-to-body="true" tooltip-trigger="\'focus mouseenter\'" tooltip-class="'+tooltipClass+'">',
                                    '<span class="sr-only">'+tooltipText+'</span>',
                                '</'+tooltipTag+'>'].join("");


                            if(attrs.tooltipAppend=="true"){ // just for command links
                                // append element with compiled tooltip
                                element.append( $compile(tooltip)(scope) );
                            } else { // LABEL
                                // insert compiled tooltip after label
                                element.after( $compile(tooltip)(scope) );
                            }

                        } else {
                            if(elementTagName!='A' && ENVIRONMENT == 'development'){
                                console.warn([
                                    'xms-tooltip on this page has been placed on element other than <a> or <label>.',
                                    ' For accessibility reasons most of the tooltips should be placed on <a> or <label> elements.',
                                    ' It\'s not an error if it was placed on purpose. Also this warning will not show on Live.'].join(''));
                            }
                            element.removeAttr('xms-tooltip');

                            element.attr('uib-tooltip-html','tooltipText')
                                   .attr('tooltip-placement', tooltipPlacement)
                                   .attr('tabindex','0')
                                   .attr('tooltip-class', tooltipClass)

                            if (angular.isDefined(attrs.tooltipAppendToBody)) {
                                element.attr('tooltip-append-to-body', attrs.tooltipAppendToBody)
                            } else {
                                element.attr('tooltip-append-to-body', 'true')
                            }

                            if(alwaysShow || alwaysShowModal) {
                                element.attr('tooltip-trigger',"'none'");
                                if(alwaysShow){
                                    element.attr('tooltip-is-open',attrs.alwaysShow);
                                }
                                if(alwaysShowModal){
                                    element.attr('tooltip-is-open',attrs.alwaysShowModal);
                                }
                            }else{
                                element.attr('tooltip-trigger',"'focus mouseenter'");
                            }

                            if(elementTagName!='INPUT'){
                                element.append('<span class="sr-only">'+tooltipText+'</span>');

                                if( !angular.isDefined(attrs.tooltipIcon) || attrs.tooltipIcon!='false' ){
                                    element.addClass('tooltip-icon glyphicon glyphicon-question-sign');
                                }
                            }

                            $compile(element)(scope);
                        }
                    } // exit init

                }
            }
        };
    }
    xmsTooltip.$inject = ['$compile', '$sanitize', 'ajaxCall'];
    angular.module('app').directive('xmsTooltip', xmsTooltip);

}());